var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeThreedots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1024 767",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-1096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pre-home",
    transform: "matrix(14.3038,0,0,10.3897,2971.01,493.081)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -207.707,
    y: 58.037,
    width: 71.589,
    height: 73.792,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "first-dot",
    transform: "matrix(0.0671226,0,0,0.092035,-216.743,3.18146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M824.678,1219.67C821.189,1216.18 818.392,1211.99 816.447,1207.38C814.492,1202.64 813.366,1197.47 813.366,1192.3C813.366,1181.83 817.426,1172.06 824.678,1164.79C832.08,1157.4 841.711,1153.34 852.047,1153.34C857.354,1153.34 862.381,1154.32 867.271,1156.42C871.875,1158.37 876.071,1161.16 879.698,1164.79C887.235,1172.19 891.282,1181.97 891.282,1192.3C891.282,1197.47 890.305,1202.64 888.212,1207.38C886.259,1211.99 883.324,1216.18 879.698,1219.67C876.071,1223.3 871.875,1226.09 867.271,1228.05C862.381,1230.14 857.354,1231.12 852.047,1231.12C841.711,1231.12 832.08,1227.07 824.678,1219.67Z",
    style: {
      fill: "rgb(60,60,60)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "second-dot",
    transform: "matrix(0.0698823,0,0,0.0961012,-219.063,-19.8111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M824.678,1219.67C821.189,1216.18 818.392,1211.99 816.447,1207.38C814.492,1202.64 813.366,1197.47 813.366,1192.3C813.366,1181.83 817.426,1172.06 824.678,1164.79C832.08,1157.4 841.711,1153.34 852.047,1153.34C857.354,1153.34 862.381,1154.32 867.271,1156.42C871.875,1158.37 876.071,1161.16 879.698,1164.79C887.235,1172.19 891.282,1181.97 891.282,1192.3C891.282,1197.47 890.305,1202.64 888.212,1207.38C886.259,1211.99 883.324,1216.18 879.698,1219.67C876.071,1223.3 871.875,1226.09 867.271,1228.05C862.381,1230.14 857.354,1231.12 852.047,1231.12C841.711,1231.12 832.08,1227.07 824.678,1219.67Z",
    style: {
      fill: "rgb(60,60,60)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "third-dot",
    transform: "matrix(0.0698823,0,0,0.0961012,-219.063,-37.7399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M824.678,1219.67C821.189,1216.18 818.392,1211.99 816.447,1207.38C814.492,1202.64 813.366,1197.47 813.366,1192.3C813.366,1181.83 817.426,1172.06 824.678,1164.79C832.08,1157.4 841.711,1153.34 852.047,1153.34C857.354,1153.34 862.381,1154.32 867.271,1156.42C871.875,1158.37 876.071,1161.16 879.698,1164.79C887.235,1172.19 891.282,1181.97 891.282,1192.3C891.282,1197.47 890.305,1202.64 888.212,1207.38C886.259,1211.99 883.324,1216.18 879.698,1219.67C876.071,1223.3 871.875,1226.09 867.271,1228.05C862.381,1230.14 857.354,1231.12 852.047,1231.12C841.711,1231.12 832.08,1227.07 824.678,1219.67Z",
    style: {
      fill: "rgb(60,60,60)",
      fillRule: "nonzero"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeThreedots);
export default __webpack_public_path__ + "static/media/home-threedots.9be428c6acf44043034f2a520f3ecfd2.svg";
export { ForwardRef as ReactComponent };